import { createFileRoute } from "@tanstack/react-router";

import { PdfEditorPage } from "@/features/pdf-editor/components/pdf-editor-page";

export const Route = createFileRoute("/_authed/documents/$fileId/pdf")({
  component: PdfEditorRoute,
});

function PdfEditorRoute() {
  const { fileId } = Route.useParams();
  return <PdfEditorPage fileId={fileId} />;
}
